export default __webpack_public_path__ + "src/assets/buy.8ec86c1328754a69cf52f75214abdde6.svg";